import { Fare, formatName, Porter } from '@silbo/core';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { usePortersContext } from '../contexts/usePortersContext';

/**
 * A hook to get other porters assigned to a fare, excluding the current porter
 *
 * @param fare - The fare object containing porters
 * @returns An object containing the names of other assigned porters
 */
export const useOtherAssignedPorters = (fare: Fare) => {
  const { user } = useAuthenticationContext();
  const { porters } = usePortersContext();

  const farePortersIds = fare.porters?.map((porter: Porter) => porter.id);

  const otherAssignedPorters = porters
    ?.filter((porter) => {
      return farePortersIds?.includes(porter.id) && porter.id !== user?.porter?.id;
    })
    .map((porter) => {
      return formatName(porter.firstName, porter.lastName);
    })
    .join(', ');

  return { otherAssignedPorters };
};
